function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Window_closed"
}, /*#__PURE__*/React.createElement("title", null, "VF_window_closed_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M0 14.2v255.1h283.5V14.2H0zm28.4 28.3h99.1v92.1H99.2v14.2h28.3v92.1H28.4V42.5zm226.7 198.4h-99.3v-92.1h28.4v-14.2h-28.4V42.5h99.3v198.4z"
}))));